
import {TextMessage} from '../email/TextMessage';
import {SocialMedia} from './socialMedia';
import {JsonObject, JsonProperty} from 'json2typescript';
import {ExternalLinkConverter} from '../../customJsonConverters/ExternalLinkConverter';
import {ExternalLink} from './externalLink';
import {TextMessageConverter} from '../../customJsonConverters/TextMessageConverter';

export class Download extends SocialMedia {

    // TODO: Tobe removed once inheritance concept is cleared in json2Typescript

   /* @JsonProperty('shareClass')
    public shareClass = '';

    @JsonProperty('clickArea')
    public clickArea = '';

    @JsonProperty('configFile')
    public configFile = '';

    @JsonProperty('link',ExternalLinkConverter)
    public link = new ExternalLink();

    @JsonProperty('image')
    public image = '';*/
    //


    @JsonProperty('download_image')
    download_image = false;

    // in regards to microsite
    @JsonProperty('name')
    name = '';

    @JsonProperty('emailSubject',TextMessageConverter)
    emailSubject = new TextMessage;

    @JsonProperty('emailFrom',TextMessageConverter)
    emailFrom = new TextMessage;

    @JsonProperty('emailText',TextMessageConverter)
    emailText:TextMessage;

    constructor() {
      super();
       /* this.emailSubject = new TextMessage();
        this.emailFrom = new TextMessage();
        this.emailText = new TextMessage();*/
    }


}
